import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDgSUGZXMezd4xS8fqhko9qMoefxUW9YK4",  
    authDomain: "kopacopy-diamond-topup.firebaseapp.com",  
    projectId: "kopacopy-diamond-topup",  
    storageBucket: "kopacopy-diamond-topup.appspot.com",  
    messagingSenderId: "244208789911",  
    appId: "1:244208789911:web:ac63b6b21ed96cf5b1fcd2",  
    measurementId: "G-M5224BJKWJ"
};
// Initialize Firebase
// const db = firebase.initializeApp(firebaseConfig);

// export default db.database().ref();
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
// const firebaseAuth = firebase.auth();
export { firebase };
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export default db;